<app-firstname class="d-block" [userId]="userId" [color]="color"></app-firstname>
<app-lastname class="d-block mt-4" [userId]="userId" [color]="color"></app-lastname>
<app-email class="d-block mt-4" [userId]="userId" [color]="color"></app-email>